import React, { useState, useEffect } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useMediaQuery, Typography } from '@mui/material';
import { GradeSelectorSelect } from 'components/GradeSelector';

import VideoActivity from 'components/StudentView/VideoActivity';
import GameActivity from 'components/StudentView/GameActivity';
import WrittenActivity from 'components/StudentView/QuizOpenEnded';
import DrawingActivity from 'components/StudentView/QuizDrawResponse';
import QuizSingle from 'components/StudentView/QuizSingleAnswer';
import QuizMulti from 'components/StudentView/QuizMultiAnswer';
import QuizLikert from 'components/StudentView/QuizLikert';
import { isMobile } from '@lsgo/lsgo-common';
import axios from 'config/axios';
import ImageLoader from 'components/UI/ImageLoader';

const miniActivityFactory = (activity) => {
    switch (activity.activityType) {
        case 400:
            return VideoActivity;
        case 300:
            return GameActivity;
        case 301:
            return GameActivity;
        case 104:
            return DrawingActivity;
        case 103:
            return WrittenActivity;
        case 102:
            return QuizMulti;
        case 101:
            return QuizSingle;
        case 10001:
            return QuizLikert;
        default:
            return QuizSingle;
    }
};

const PreviewModal = (props) => {
    const [viewingActivity, setViewingActivity] = useState(
        props.lessonToPreview ? props.lessonToPreview?.lessons[0]?.activities[0].activityId : 1,
    );
    const [currentStage, setCurrentStage] = useState(0);
    const [resources, setResources] = useState(null);
    const fullScreen = useMediaQuery('(max-width:767px)') || isMobile(navigator);
    const lessonComingSoon = props.lessonToPreview && !!props.lessonToPreview.incompleteLesson;

    const currentStageLesson = props.lessonToPreview?.lessons.find((l) => l.gradeId === currentStage);

    const mapCards = (cards) => {
        console.log(cards);
        if (!cards) {
            return null;
        }
        return cards.map((card) => {
            const imageLink = card.image;
            return (
                <div
                    className={`col-lg-3 col-md-4 col-sm-6 col-12 mb-4 cursor-pointer`}
                    key={`card-${card.resourceId}`}
                    onClick={() => {
                        !card.viewDisabled && window.open(card.url, '_blank');
                        card.viewDisabled && window.open(card.shopUrl);
                    }}
                >
                    <div className='card resource-card' style={{ height: '100%' }}>
                        <div className='card-body shadow' style={{ borderRadius: '0.25rem' }}>
                            {Boolean(card.viewDisabled) && (
                                <div className='banner orange-light'>
                                    <span>Upgrade</span>
                                </div>
                            )}
                            <div className='preview my-2'>
                                <div
                                    className='text-center resource-image'
                                    style={{
                                        filter: card.viewDisabled ? 'grayscale(100%)' : '',
                                    }}
                                >
                                    <ImageLoader loadImage={imageLink} imageAlt={card.title} height={200} />
                                </div>
                            </div>
                            <div className='card-tooltip text-center'>
                                <span>{card.title}</span>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });
    };

    useEffect(() => {
        if (props.lessonToPreview === null) {
            setViewingActivity(1);
        }
        //eslint-disable-next-line
    }, [props.lessonToPreview]);

    useEffect(() => {
        if (props.lessonToPreview)
            setViewingActivity(
                currentStageLesson.activities.find((activity) => activity.activityType === 400).activityId,
            );
    }, [currentStage]);

    useEffect(() => {
        if (props.lessonToPreview?.groupId && viewingActivity === 'lesson_resources') {
            axios.get(`/api/v4/lessons/${props.lessonToPreview?.groupId}/resources`).then((data) => {
                setResources(data.data);
            });
        }
    }, [props.lessonToPreview, viewingActivity]);

    const activityObject =
        props.lessonToPreview &&
        currentStageLesson.activities.find((activity) => activity.activityId === viewingActivity);
    const ActivityComponent = activityObject && miniActivityFactory(activityObject);

    const activityArray =
        props.lessonToPreview &&
        [
            ...currentStageLesson.activities
                /* .sort((a, b) => {
                    return a.LessonsActivities.order > b.LessonsActivities.order ? 1 : -1;
                }) */
                .filter((act) => act.activityType !== 500)
                .reduce((acc, element) => {
                    if (element.activityType === 400) {
                        return [element, ...acc];
                    } else if (element.activityType === 300 || element.activityType === 310) {
                        return acc;
                    } else {
                        return [...acc, element];
                    }
                }, []),
            currentStageLesson.activities.find((a) => a.activityType === 300 || a.activityType === 310),
        ]
            .filter(Boolean)
            .sort((a, b) => {
                return a.LessonsActivities.order < b.LessonsActivities.order ? -1 : 1;
            })
            .map((activity, index) => {
                if (index === 0 && viewingActivity === 1) {
                    setViewingActivity(activity.activityId);
                }
                const title =
                    activity.activityType === 400
                        ? 'Video'
                        : activity.activityType === 300 || activity.activityType === 301
                          ? 'Game'
                          : currentStageLesson.type === 2
                            ? activity.activityType === 104
                                ? 'Journal'
                                : activity.LessonsActivities.order === 1
                                  ? 'Pre Question'
                                  : 'Post Question'
                            : `Q${activity.LessonsActivities.order}`;
                return { id: activity.activityId, value: title };
            });

    return (
        <Dialog
            maxWidth='md'
            className='badges-dialog'
            open={props.lessonToPreview ? true : false}
            fullWidth={true}
            fullScreen={fullScreen}
            onClose={() => props.togglePreviewLessonModal(null)}
        >
            <DialogTitle>
                {lessonComingSoon && (
                    <div
                        style={{
                            backgroundColor: '#ffcc00',
                        }}
                        className='row'
                    >
                        <i className='fas fa-exclamation-circle' style={{ margin: 5 }} />
                        <Typography variant='body1' style={{ margin: 5 }}>
                            These lessons are targeted for Primary School students.
                        </Typography>
                    </div>
                )}
                Preview -{' '}
                {props.lessonToPreview && (props.lessonToPreview.displayName || props.lessonToPreview.lessonName)}
                <span className='close-dialog pull-right' onClick={() => props.togglePreviewLessonModal(null)}>
                    <i className='far fa-times-circle' />
                </span>
            </DialogTitle>
            <DialogContent id='lesson-preview-dialog'>
                <div style={{ display: 'block' }}>
                    <GradeSelectorSelect
                        value={currentStage}
                        stages
                        filter={[0, 1, 2, 3, 4, 5, 6]}
                        selectField
                        onChange={(v) => setCurrentStage(+v.target.value)}
                    />
                </div>
                Curriculum Outcomes:
                <ul>
                    {currentStageLesson?.lesson_curriculum_outcomes?.map((co) => {
                        return (
                            <li>
                                <Typography variant='subtitle'>
                                    {co.code}: {co.description}
                                </Typography>
                            </li>
                        );
                    })}
                </ul>
                <ul className='nav nav-tabs' style={{ marginBottom: 6 }}>
                    {activityArray &&
                        activityArray.map((activityLabel) => {
                            return (
                                <li
                                    className='nav-item text-center cursor-pointer'
                                    key={`grade-${activityLabel.id}`}
                                    value={activityLabel.id}
                                    style={{ width: `${100 / (activityArray.length + 1)}%` }}
                                >
                                    <span
                                        className={`nav-link ${activityLabel.id === viewingActivity ? 'active' : ''}`}
                                        onClick={() => setViewingActivity(activityLabel.id)}
                                    >
                                        {activityLabel.value}
                                    </span>
                                </li>
                            );
                        })}
                    <li
                        className='nav-item text-center cursor-pointer'
                        key={`grade-lesson-resources`}
                        value={'lesson_resources'}
                        style={{ width: `${100 / (activityArray && activityArray.length + 1)}%` }}
                    >
                        <span
                            className={`nav-link ${'lesson_resources' === viewingActivity ? 'active' : ''}`}
                            onClick={() => setViewingActivity('lesson_resources')}
                        >
                            Resources
                        </span>
                    </li>
                </ul>
                <div className='studentv2 activities-preview'>
                    <div className='student-box2'>
                        {activityObject ? (
                            <ActivityComponent
                                {...activityObject}
                                {...activityObject.content}
                                demoMode
                                context={'teacher_lesson_preview'}
                            />
                        ) : viewingActivity === 'lesson_resources' ? (
                            <div className='col-12'>
                                <Typography variant='h6'>Lesson Resources</Typography>
                                <div className='row'>{mapCards(resources?.LR)}</div>
                                <Typography variant='h6'>Additional Activities</Typography>
                                <div className='row'>{mapCards(resources?.AA)}</div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default PreviewModal;
